import {HStack} from '@chakra-ui/layout';
import {Alert, Box, Button} from '@chakra-ui/react';
import {ReactNode} from 'react';
import {CloseIcon} from '@/components/svg/CloseIcon';
import {CheckCircleToastIcon} from '@/components/svg/CheckCircleIcon';
import {WarningSignIcon} from '@/components/svg/WarningSignIcon';
import {TextToastCommandVariant} from 'ff-common/src/types/TextToastCommand';

export const CustomToast: React.FC<{
  icon?: ReactNode;
  body: ReactNode;
  onClose: () => void;
  variant?: TextToastCommandVariant;
}> = ({icon, body, onClose, variant = 'success'}) => {
  const isWarning = variant === 'warning';
  // En warning : bordure/croix orange et icône d'alerte ; en success : vert + check (défaut historique)
  const accentColor = isWarning ? 'orange.warning' : 'green.success';
  const defaultIcon = isWarning ? (
    <WarningSignIcon
      color='orange.warning'
      width='20px'
      height='18px'
    />
  ) : (
    <CheckCircleToastIcon />
  );
  return (
    <Alert
      borderRadius='8px'
      borderColor={accentColor}
    >
      <HStack
        alignItems='start'
        pr='4'
      >
        {icon ?? defaultIcon}
        <Box maxW='300px'>{body}</Box>
      </HStack>
      <Button
        variant='ghost'
        onClick={onClose}
        p='1'
        position='absolute'
        right='0'
        top='0'
      >
        <CloseIcon color={accentColor} />
      </Button>
    </Alert>
  );
};
